import { createAtomObserver } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';
import type Emitter from '@exodus/wild-emitter';

import type { TestnetsEnabledAtom } from '@/background/features/testnets/atoms';
import type { Testnets } from '@/background/features/testnets/module';

type Dependencies = {
  port: Emitter;
  testnetsEnabledAtom: TestnetsEnabledAtom;
  testnets: Testnets;
};

const createTestnetsPlugin = ({
  port,
  testnets,
  testnetsEnabledAtom,
}: Dependencies) => {
  const observer = createAtomObserver({
    port,
    atom: testnetsEnabledAtom,
    event: 'testnetsEnabled',
  });

  const onStart = async () => {
    observer.start();
    const testnetsEnabled = await testnetsEnabledAtom.get();
    // disable all testnets the first time the application starts
    if (testnetsEnabled === null) {
      await testnetsEnabledAtom.set(false);
      await testnets.disableAssets();
    }
  };

  const onStop = () => {
    observer.unregister();
  };

  return { onStart, onStop };
};

const testnetsPluginDefinition = {
  id: 'testnetsPlugin',
  type: 'plugin',
  factory: createTestnetsPlugin,
  dependencies: ['port', 'testnetsEnabledAtom', 'testnets'],
} as const satisfies Definition;

export default testnetsPluginDefinition;
